import { useNavigate } from "react-router-dom";
import { Button, Card, Form, Input, Space, Typography } from "antd";
import { MailOutlined } from "@ant-design/icons";
import AuthShell from "components/auth/AuthShell";
import AuthBrand from "components/auth/AuthBrand";
import useAccountRecovery from "hooks/auth/useAccountRecovery";
import paths from "routes/paths";

const { Title, Text, Paragraph } = Typography;

const AuthRecoverRequest = () => {
  const navigate = useNavigate();
  const { requestPasswordReset, isLoading } = useAccountRecovery();

  const submit = async (values) => {
    if (!values.email) return;
    const res = await requestPasswordReset(values.email);
    if (res?.success) {
      navigate(paths.simpleVerificationCode, { replace: true });
    }
  };

  return (
    <AuthShell>
      <Card
        variant="borderless"
        style={{
          width: "100%",
          maxWidth: 520,
          borderRadius: 28,
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.10)",
          border: "1px solid rgba(226,232,240,0.95)",
          background: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(18px)",
        }}
        styles={{ body: { padding: 32 } }}
      >
        <div style={{ marginBottom: 24, textAlign: "center" }}>
          <AuthBrand centered size={96} />
        </div>
        <Space vertical size={8} style={{ width: "100%" }}>
          <Text
            style={{
              textTransform: "uppercase",
              letterSpacing: "0.14em",
              color: "#64748b",
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            Reset access
          </Text>
          <Title level={2} style={{ margin: 0, color: "#111827" }}>
            Forgot your password?
          </Title>
          <Paragraph style={{ marginBottom: 0, color: "#475569" }}>
            Enter your email address and we will send a verification code.
          </Paragraph>
        </Space>

        <Form layout="vertical" requiredMark={false} onFinish={submit} style={{ marginTop: 24 }}>
          <Form.Item
            label="Email address"
            name="email"
            rules={[
              { required: true, message: "Email address is required" },
              { type: "email", message: "Enter a valid email address" },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
              placeholder="you@example.com"
              disabled={isLoading}
              size="large"
              inputMode="email"
            />
          </Form.Item>

          <Space style={{ width: "100%", justifyContent: "space-between" }} wrap>
            <Button onClick={() => navigate(paths.simpleLogin)} disabled={isLoading}>
              Back to sign in
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              style={{ backgroundColor: "#22c55e", borderColor: "#22c55e" }}
            >
              Send verification code
            </Button>
          </Space>
        </Form>
      </Card>
    </AuthShell>
  );
};

export default AuthRecoverRequest;
